import React, {FC} from "react"

import authentication from "@irati/auth"
import {CompanyNewsTile} from "@irati/types"
import {getInternalLinkFromString} from "@irati/utils/links"
import {cultureHubTracking} from "@irati-tracking/homepage"

import {StyledLink} from "./styled"

interface Props {
  children: JSX.Element
  companyNewsTile: CompanyNewsTile
}

const LinkWrapper: FC<Props> = ({children, companyNewsTile}) => {
  const {url} = companyNewsTile.config

  if (url) {
    const internalUrl = getInternalLinkFromString(url, authentication.userTenant().subdomain)
    if (internalUrl) {
      return <StyledLink href={internalUrl}>{children}</StyledLink>
    }

    return (
      <StyledLink onClick={() => cultureHubTracking.cultureHubTileClick(url)} href={url} target="_blank" rel="noopener noreferrer">
        {children}
      </StyledLink>
    )
  }

  return children
}

export default LinkWrapper
